console.log('Vite ⚡️ Rails')

import { Turbo } from '@hotwired/turbo-rails'
Turbo.start()

import '/controllers'
import '/channels'
// import '/turbo_streams'

import Trix from 'trix'

Trix.config.blockAttributes.heading1.tagName = 'h3'
